<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Premium Care Member Status</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <app-data-form
      [dataFields]="form"
      dataName="form"
      (updateFields_child)="updateFields($event)"
    />
    <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" (click)="printStatus()">
        <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Print
      </button>
      <button class="shorter-btn clear-btn" (click)="clearForm()">
        <fa-icon [icon]="faEraser" class="mr-1"></fa-icon>Clear
      </button>
    </div>
  </div>
</section>
